import { render, staticRenderFns } from "./DemographicProfilePdf.vue?vue&type=template&id=c2e2e246&scoped=true"
import script from "./DemographicProfilePdf.vue?vue&type=script&lang=js"
export * from "./DemographicProfilePdf.vue?vue&type=script&lang=js"
import style0 from "./DemographicProfilePdf.vue?vue&type=style&index=0&id=c2e2e246&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2e2e246",
  null
  
)

export default component.exports